// UI strings for the measurement (docs/PEDAGOGY.md §5): the one optional tap after the daily and
// the couple session (pedagogy/SessionRating.tsx; decision 1 of 2026-10-06: text, no faces).
// Finnish (default) and English side by side; en has the same shape. docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const measureFi = {
  rating: {
    question: 'Miten tämä toimi?',
    good: 'Hyvin',
    ok: 'Ihan ok',
    bad: 'Ei oikein',
    skip: 'Ohita',
    /** Screen readers, after a tap. */
    saved: 'Vastaus tallennettu.',
  },
};

export const measureEn: typeof measureFi = {
  rating: {
    question: 'How did this go?',
    good: 'Well',
    ok: 'All right',
    bad: 'Not really',
    skip: 'Skip',
    saved: 'Answer saved.',
  },
};

// Messages.measure (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('measure', measureFi, measureEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof measureFi> {}
}
